import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export default function ErrorModalComponent({ show, title, message, onClose }) {
  if (!show) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{
          zIndex: 1040,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1050 }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div
            className="modal-content border-0 shadow-lg"
            style={{
              borderRadius: "20px",
              maxWidth: "500px",
              margin: "auto",
            }}
          >
            {/* Modal Body */}
            <div className="modal-body text-center py-5 px-4">
              {/* Error Icon with Cross */}
              <div className="mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                  style={{
                    width: 80,
                    height: 80,
                    backgroundColor: "#dc3545",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    className="text-white"
                    size="3x"
                  />
                </div>
              </div>

              {/* Title */}
              {title && (
                <h5
                  className="mb-3 fw-bold"
                  style={{
                    color: "#2c3e50",
                    fontSize: "1.5rem",
                  }}
                >
                  {title}
                </h5>
              )}

              {/* Message */}
              <p
                className="mb-4"
                style={{
                  color: "#6c757d",
                  fontSize: "1.1rem",
                  lineHeight: "1.6",
                }}
              >
                {message}
              </p>

              {/* Close Button */}
              <button
                type="button"
                className="btn btn-danger btn-lg px-5"
                onClick={onClose}
                style={{
                  fontWeight: "500",
                  fontSize: "1.1rem",
                  padding: "12px 48px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
